/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import { goBack } from 'connected-react-router'
import editBureauActions, {
    editBureauTypes,
} from '../../../redux/bureau/editBureau'
import getAllBureauxActions from '../../../redux/bureau/getAllBureaux'
import { Put } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* editBureauSagas({ response }) {
    try {
        const res = yield Put(`bureauemploi/${response.id}`, response)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(getAllBureauxActions.getAllBureauxRequest()),
                yield put(
                    editBureauActions.editBureauSuccess(res.data)
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
                yield put(goBack()),
                yield put(editBureauActions.editBureauSuccess(null)),
                yield put(
                    getAllBureauxActions.getAllBureauxRequest()
                ),
            ])
        } else {
            yield put(editBureauActions.editBureauFailure(res))
        }
    } catch (error) {
        yield put(editBureauActions.editBureauFailure(error))
    }
}

export function* editBureauSaga() {
    yield takeLatest(
        editBureauTypes.EDIT_BUREAU_REQUEST,
        editBureauSagas
    )
}
